import { Pagination } from "./../../Service/model";
// import UIFetchService from "../../Service/UIFetchService";
import {
  SearchSubscription,
  SubscriptionItem,
  UpdateSubscription,
} from "./model";
import { faker } from "@faker-js/faker";
import UIFetchService from "../../Service/UIFetchService";
import qs from "qs";

const fakeData: SubscriptionItem[] = [];

export const getSubscriptionList = async (
  search: SearchSubscription,
  page: Pagination
) => {
  const res = await UIFetchService.get(
    `/api/v1/querying_indicator/indicator_reports?${qs.stringify({
      pageSize: page.pageSize,
      pageNo: page.pageNo,
      key: search.searchKey,
    })}`
  );
  return res;
};

// 0未订阅1已订阅
export const changeStatus = async (param: { id: number; status: boolean }) => {
  const res = await UIFetchService.put(
    `/api/v1/querying_indicator/indicator_reports/${param.id}/status`,
    {
      status: param.status === true ? 1 : 0,
    }
  );
  return res;
};

export const updateSubscription = async (
  id: number | null,
  target: UpdateSubscription
) => {
  const res = await UIFetchService.put(
    `/api/v1/querying_indicator/indicator_reports/${id}`,
    { ...target, id: id }
  );
  return res;
};
export const addSubscription = async (target: UpdateSubscription) => {
  const res = await UIFetchService.post(
    `/api/v1/querying_indicator/indicator_report`,
    target
  );
  return res;
};

export const getSubScription = async (id: number) => {
  return await UIFetchService.get(
    `/api/v1/querying_indicator/indicator_reports/${id}`
  );
};

export const duplicate = async (id: number) => {
  const res = await UIFetchService.post(
    `/api/v1/querying_indicator/indicator_reports/${id}/clone`
  );
  return res;
};

export const delSubscription = async (id: number) => {
  const res = await UIFetchService.delete(
    `/api/v1/querying_indicator/indicator_reports/${id}`
  );
  return res;
};

export const getMyIndexList = async (
  data: { group: string; process: string; name: string },
  page: Pagination
) => {
  return {
    data: fakeData.slice(
      (page.pageNo - 1) * page.pageSize,
      page.pageNo * page.pageSize
    ),
    total: fakeData.length,
  };
};

export const testSubscription = async (id: number) => {
  const res = await UIFetchService.post(
    `/api/v1/querying_indicator/indicator_reports/${id}/send`
  );
  return res;
};

export const getTeams = async () => {
  const res = await UIFetchService.get('/api/v1/perm/teams');
  return res;
};


